import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import BacktestService from "../../../../service/backtest.service";
import Spinner from "../Datatable/spinner/spinner";
import RebalanceHolder from "./rebalanceHolder";
import NoDataAvailable from "../../../common/errorBoundary/noDataAvailable";

class RebalanceDashboard extends Component {
  state = {
    live: [],
    current: [],
    spinner: false,
    loaded: false,
  };

  async componentDidMount() {
    var { scenario_id, benchmark, getBacktest } = this.props;

    this.setState({
      live: getBacktest.getPortfolioData,
    });
    if (scenario_id && benchmark) {
      this.setState({
        spinner: true,
      });
      try {
        await BacktestService.getBacktest(
          `${scenario_id}`,
          `${benchmark}`,
          "CURRENT"
        ).then((res) => {
          if (res) {
            this.setState({
              current: res.getPortfolioData,
              spinner: false,
              loaded: true,
            });
          }
        });
      } catch (error) {
        this.setState({
          spinner: false,
          loaded: false,
        });
      }
    }
  }

  async componentWillReceiveProps(nextProps) {
    var { scenario_id, benchmark, getBacktest } = nextProps;

    this.setState({
      live: getBacktest.getPortfolioData,
    });
    if (this.props.scenario_id !== scenario_id) {
      this.setState({
        spinner: true,
      });
      try {
        await BacktestService.getBacktest(
          `${scenario_id}`,
          `${benchmark}`,
          "CURRENT"
        ).then((res) => {
          if (res) {
            this.setState({
              current: res.getPortfolioData,
              spinner: false,
              loaded: true,
            });
          }
        });
      } catch (error) {
        this.setState({
          spinner: false,
          loaded: false,
        });
      }
    }
  }

  render() {
    const { live, current, spinner, loaded } = this.state;
    return (
      <Fragment>
        {spinner ? <Spinner /> : null}
        {loaded ? (
          <Fragment>
            {live ? (
              <RebalanceHolder
                live={live}
                current={current}
                heading={this.props.heading}
              />
            ) : (
              <NoDataAvailable />
            )}
          </Fragment>
        ) : null}
      </Fragment>
    );
  }
}

RebalanceDashboard.propTypes = {
  scenario_id: PropTypes.number.isRequired,
  benchmark: PropTypes.string.isRequired,
  getBacktest: PropTypes.object.isRequired,
};

export default RebalanceDashboard;



// WEBPACK FOOTER //
// ./src/components/PortfolioDashboard/navigationPages/Rebalance/rebalance.jsx